<template>
  <div class="l-score-container">
    <!-- 选项，展示正确/总数 -->
    <Summary v-if="ELEMENT_TYPES.ABC_OPTIONS_TEST === SOURCE_TO_ELEMENT[element.type]
      || ELEMENT_TYPES.EXAM === SOURCE_TO_ELEMENT[element.type] 
    " :total="total" :right="right" />
    <SummaryAudioSort
      v-if="ELEMENT_TYPES.AUDIO_SORT === SOURCE_TO_ELEMENT[element.type]
      || ELEMENT_TYPES.EXPLAIN_AND_UNDERSTAND === SOURCE_TO_ELEMENT[element.type]"
      :total="total"
      :right="right" />
    <!-- 展示元素结果，以及每个测评题评价词 -->
    <SummaryTable v-if="ELEMENT_TYPES.AUDIO_TEST === SOURCE_TO_ELEMENT[element.type]
      || ELEMENT_TYPES.AUDIO_READ === SOURCE_TO_ELEMENT[element.type]
      || ELEMENT_TYPES.EXPLAIN_TEST === SOURCE_TO_ELEMENT[element.type]
      || ELEMENT_TYPES.ABC_EXPLAIN_TEST === SOURCE_TO_ELEMENT[element.type]" :element="element" :result="result" />
    <!-- 展示录音 -->
    <SummaryAudio v-if="ELEMENT_TYPES.SELF_READING_TEST === SOURCE_TO_ELEMENT[element.type]" :element="element"
      :result="result" />
  </div>
</template>

<script>
import Summary from './summary.vue'
import SummaryTable from './summary-table.vue'
import SummaryAudio from './summary-audio.vue'
import SummaryAudioSort from './summary-audio-sort.vue'
import elementTypes from '../../minxin/elementTypes'

export default {
  components: { Summary, SummaryTable, SummaryAudio, SummaryAudioSort },
  props: {
    element: [Object],
    result: [Object],
  },
  mixins: [elementTypes],
  data() {
    return {
      right: 0,
      total: 0,
    }
  },
  mounted() {
    this._summary()
  },
  methods: {
    _summary() {
      // 弹窗接口
      this.element.records?.forEach((item) => {
        if (item.right) {
          this.right += 1
        }
      })
      this.total = this.element.totalCount
    },
  },
}
</script>
<style lang="stylus" scoped>
.l-score-container
  width 100%
  padding 0
  overflow-y auto
</style>
